import React from 'react';
import {
  CardActions,
  CreateButton,
  Button
} from "react-admin";
import GetApp from '@material-ui/icons/GetApp';
const saveAs = require('file-saver');

// export const exporterCustom = (fields, csvName) => {
//   return posts => {
//       const csv = convertToCSV({
//           data: posts,
//           fields: fields // select and order fields in the export
//       });
//       downloadCSV(csv, csvName); // download as 'csvName.csv` file
//   }
// }
const esc = encodeURIComponent;
const handleClick = (p) => {
  const jwt = window.localStorage.getItem("feathers-jwt");

  var filter = Object.keys(p.filterValues)
      .map(k => esc(k) + '=' + esc(p.filterValues[k]))
      .join('&');

  const url = process.env.REACT_APP_API_URL + '/' + p.resource + '.csv?' + filter

  fetch(
    url,
    {
      'method': 'get',
      "headers": {
        "Authorization": "Bearer " + jwt
      }
    })
    .then(response => response.blob())
    .then(blob => {
      const filename = p.resource + '.csv';
      saveAs(blob, filename)
    })
}

export const actionListCustom = ( exporter ) => {
  return ({ resource, filters, displayedFilters, filterValues, basePath, showFilter, total, currentSort }) => (
      <CardActions>
          {filters && React.cloneElement(filters, {
              resource,
              showFilter,
              displayedFilters,
              filterValues,
              context: 'button',
          }) }
          <CreateButton basePath={basePath} />
          <Button
            label="EXPORT"
            onClick={() => handleClick({resource, filters, displayedFilters, filterValues, basePath, showFilter, total, currentSort})}
          >
            <GetApp />
          </Button>
      </CardActions>
  );
}



// WEBPACK FOOTER //
// ./src/components/Wow/actionListCustom.js